import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PreferenceService } from '../../services/preference.service';

const UNITS2 = {
  distance: 'UNITS.DISTANCE',
  speed: 'UNITS.SPEED',
  speedBoat: 'UNITS.SPEED_BOAT',
  none: '',
} as const;

@Pipe({
  name: 'imperial',
})
export default class ImperialPipe implements PipeTransform {
  private localeStr = this.preferenceService.$currentLang();

  constructor(
    private translateService: TranslateService,
    private preferenceService: PreferenceService
  ) {}

  transform(value: number, format: string, decimals?: number, isNotUnit?: boolean): string {
    const unit = ' ' + (format !== 'none' ? this.translateService?.instant(UNITS2[format]) : '');
    let valueTransform: string;

    if (decimals === undefined) {
      decimals = 2;
    }

    if (this.localeStr === 'en') {
      valueTransform =
        format === 'speedBoat'
          ? (Number(value) * 0.539957).toFixed(decimals)
          : (Number(value) * 0.621371).toFixed(decimals);

      const valueFinal =
        isNaN(Number(valueTransform)) || Number(valueTransform) === Infinity ? 0 : valueTransform;

      return isNotUnit ? `${valueFinal}` : valueFinal + unit;
    } else {
      valueTransform =
        format === 'speedBoat'
          ? (Number(value) * 0.539957).toFixed(decimals)
          : Number(value).toFixed(decimals);

      const valueFinal =
        isNaN(Number(valueTransform)) || Number(valueTransform) === Infinity ? 0 : valueTransform;

      return isNotUnit ? `${valueFinal}` : valueFinal + unit;
    }
  }
}
